import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

class RawSubmitButtonInput extends React.Component {
  render() {
    const contents = this.props.loading ? (
      <CircularProgress size={24} color="secondary" />
    ) : (this.props.contents);

    return (
      <Grid container className={ this.props.className }>
        <Grid item xs={12}>
          <Button
            style={{ width: "100%" }}
            type="submit"
            disabled={ this.props.loading || !this.props.validForm }
            variant="contained"
            { ...this.props.elementProps }
          >
            { contents }
          </Button>
        </Grid>
      </Grid>
    );
  }
}

RawSubmitButtonInput.propTypes = {
  validForm: PropTypes.bool.isRequired,
  contents: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  className: PropTypes.string,
}

export default withFormsy(RawSubmitButtonInput);

